
import Component from '../../../assets/scripts/modules/component';

class GenericForm extends Component {
  init() {
    [...this.element.querySelectorAll('[data-role="submit"]')].forEach((submitEl) => {
      submitEl.addEventListener('click', (event) => {
        event.preventDefault();
        this.element.submit();
      });
    });
  }
}

for (const element of document.querySelectorAll('.generic-form')) {
  element.instance = new GenericForm('generic-form', element, { onLoad: true });
}



// WEBPACK FOOTER //
// ./website/components/atoms/generic-form/generic-form.js